import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import appInfo from "./app-info";
import routes from "./app-routes";
import { SideNavOuterToolbar as SideNavBarLayout } from "./layouts";
import { Footer } from "./components";

export default function (data) {
  //  const { user } = useAuth();
  return (
    <SideNavBarLayout title={appInfo.title}>
      <Switch>

        
        {routes.map(({ path, component: Component }) => (
          <Route
            exact
            key={path}
            path={path}
            render={(props) => <Component {...props} userData={data} />}
          />
        ))}


        
        {/* {routes.map(({ path, component }) => (
          <Route exact key={path} path={path} component={component} />
        ))} */}


        <Route exact path="*" component={() => <Redirect to="/home" />} />
        {/* <Redirect to={("/home", user)} /> */}
      </Switch>
      <Footer>
        Copyright © 2010-{new Date().getFullYear()} {appInfo.companyEnglishName}
        <br />
        כל הזכויות שמורות.
      </Footer>
    </SideNavBarLayout>
  );
}
